<template>
    <div class="grid">
        <div class="col-12 lg:col-5">
            <HorseHistoryChangesDataTable :changes-list="changesHistory" @showRevision="showChangesHistory"/>
        </div>
        <div v-if="selectedVersion" class="selectedVersion col-12 lg:col-7 p-4">
            <RevisionInfo :username="selectedModification.username"
                          :timestamp="selectedModification.timestamp"/>
            <div class="separator mb-3 mt-3"/>
            <div v-for="(test, index) in selectedVersion" class="history">
                <div class="font-bold">DNA samples #{{selectedVersion.length - index}}</div>
                <div>
                    <span class="label">{{ $t('message.laboratoryHorses.form.testRes') }}:</span>
                    <span>{{test.laboratoryTestStatusLabel}}</span>
                </div>
                <div>
                    <span class="label">{{ $t('message.laboratoryHorses.form.samplesFrom') }}:</span>
                    <span>{{dnaSampleTypesLabelsToString(test.dnaSampleTypesLabels)}}</span>
                </div>
                <div>
                    <span class="label">{{ $t('message.laboratoryHorses.form.batchRef') }}:</span>
                    <span>{{ test.batchRefNumber }}</span>
                </div>
                <div>
                    <span class="label">{{ $t('message.laboratoryHorses.form.testReq') }}:</span>
                    <span>{{ test.testTypeLabel }}</span>
                </div>
                <div>
                    <span class="label">{{ $t('message.laboratoryHorses.form.testPrior') }}:</span>
                    <span>{{ test.testPriorityLabel }}</span>
                </div>
                <div>
                    <span class="label">{{ $t('message.laboratoryHorses.form.shipment') }}:</span>
                    <span>{{ test.shipmentDate }}</span>
                </div>
                <div>
                    <span class="label">{{ $t('message.laboratoryHorses.form.dnaRef') }}:</span>
                    <span>{{ test.dnaReferenceNumber }}</span>
                </div>
                <div>
                    <span class="label">{{ $t('message.laboratoryHorses.form.shipment') }}:</span>
                    <span>{{ test.shipmentReceivedDate }}</span>
                </div>
                <div>
                    <span class="label">{{ $t('message.laboratoryHorses.form.comments') }}:</span>
                    <div class="comments">{{ test.notes }}</div>
                </div>
                <div class="separator mb-3 mt-3"/>
            </div>
        </div>
    </div>
</template>

<script>
import {
    getLaboratoryTestAuditTrail, getLaboratoryTestsForRevision
} from "@/swagger/vue-api-client";
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import HorseHistoryChangesDataTable
    from "@/views/horse/horseEdit/history/compontents/HorseHistoryChangesDataTable.vue";
import RevisionInfo from "@/views/horse/horseEdit/history/compontents/RevisionInfo.vue";

export default {
    name: "HorseLaboratoryHistoryTab",

    components: {
        RevisionInfo,
        HorseHistoryChangesDataTable,
        TabPanel,
        TabView
    },

    props: {
        horse: null,
    },

    data() {
        return {
            changesHistory: null,
            selectedVersion: null,
            selectedModification: {
                timestamp: null,
                username: null
            }
        };
    },

    beforeMount() {
        getLaboratoryTestAuditTrail({id: this.horse.id}).then((response => {
            this.changesHistory = response.data;
            const lastHistoryEntry = this.changesHistory.length > 0 ? this.changesHistory[0] : undefined;
            const lastRevision = lastHistoryEntry ? lastHistoryEntry.revision : null;
            if (lastRevision != null) {
                this.selectedModification.timestamp = lastHistoryEntry.timestamp;
                this.selectedModification.username = lastHistoryEntry.username;
                getLaboratoryTestsForRevision({
                    id: this.horse.id,
                    revision: lastRevision
                }).then((response) => {
                    this.selectedVersion = response.data;
                }).catch((error) => {
                    this.notifyError(error);
                });
            }
        }));
    },

    methods: {
        showChangesHistory(event) {
            if (event?.data?.revision) {
                getLaboratoryTestsForRevision({
                    id: this.horse.id,
                    revision: event.data.revision
                }).then((response) => {
                    this.selectedVersion = response.data;
                    this.selectedModification.timestamp = event?.data?.timestamp;
                    this.selectedModification.username = event?.data?.username;
                }).catch((error) => {
                    this.notifyError(error);
                });
            }
        },
        dnaSampleTypesLabelsToString(labels) {
            if (!labels) {
                return '';
            }
            return labels.join(", ");
        }
    },
};
</script>

<style lang="scss">
@import "../../../../assets/theme/mytheme/variables";
    .selectedVersion {
        background: var(--dates-background-color);
        border-radius: 7px;
    }
    .separator {
        width: 100%;
        height: 1.5px;
        background-color: var(--separator-color);
    }
    .comments {
        white-space: pre-wrap;
    }
    .history {
        color: var(--text-color);
    }
</style>
